import React, { useEffect, useState } from "react";
import "./Collection.css";
import Category from "./Category";
import Sidebar from "./Sidebar";
import ImageGrid from "../Dashboard/Image-uploader/ImageGrid";
import ImageModal from "../Dashboard/Image-uploader/ImageModal";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Scrollbar from "smooth-scrollbar";
import sal from "sal.js";
import "../../../node_modules/sal.js/dist/sal.css";

function Collection() {
  const [selectedImg, setSelectedImg] = useState(null);

  useEffect(() => {
    sal();
    var options = {
      damping: 0.05,
    };
    Scrollbar.init(document.querySelector("#my-scrollbar"), options);
  });

  return (
    <div id="my-scrollbar">
        <Navbar />
      <div className="galleries">
        <Sidebar />
        <div className="col1">
          <div className="collection">
            <h2>Life is about Creating Experiences</h2>
            <p className="head">
              Et harum quidem rerum facilis est et expedita distinctio nam
              libero tempore cum soluta nobis est eligendi optio impedit.
            </p>
            <span>Video Editing</span>
            <span>Local Studio</span>
            <span>Professional ISO</span>
            <span>Video Recording</span>
          </div>
          <div className="imgcat" id="collection-layout">
            {selectedImg && (
              <ImageModal
                selectedImg={selectedImg}
                setSelectedImg={setSelectedImg}
              />
            )}
            <ImageGrid setSelectedImg={setSelectedImg} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Collection;
